<template>
  <FormKit
      type="form"
      :value="{
          vehicle_plate:'',
          vehicle_plate_state:'',
          vehicle_plate_city:'',
          vehicle_plate_city_ibge_code:'',
          vehicle_identification_number:'',
          vehicle_renavam: '',
          vehicle_certificate: ''
      }"
      submit-label="Continuar"
      @submit="confirmData"
  >
      <h2 class="text-xl font-bold mb-1">Insira dados do veículo</h2>

      <FormKit
          type="text"
          id="vehicle_plate"
          name="vehicle_plate"
          v-model="vehicle_plate"
          label="Placa do carro*"
          :validation="[['required'], ['length', '8', '8'], ['matches', vehiclePlateRegex]]"
          validation-label="Placa do carro"
          :validation-messages="{
            matches: 'Formato de placa inválido',
          }"
          @change="(event) => vehicle_plate = normalizeVehiclePlate(event.target.value)"
      />

      <FormKit
          type="select"
          name="vehicle_plate_state"
          id="vehiclePlateState"
          label="Estado do emplacamento?*"
          placeholder="Selecione uma opção"
          validation="required"
          :validation-messages="{ required: 'O estado de emplacamento é obrigatório' }"
          :options="[
            { label: '', value: ''},
            { label: 'AC', value: 'AC'},
            { label: 'AL', value: 'AL'},
            { label: 'AP', value: 'AP'},
            { label: 'AM', value: 'AM'},
            { label: 'BA', value: 'BA'},
            { label: 'CE', value: 'CE'},
            { label: 'DF', value: 'DF'},
            { label: 'ES', value: 'ES'},
            { label: 'GO', value: 'GO'},
            { label: 'MA', value: 'MA'},
            { label: 'MT', value: 'MT'},
            { label: 'MS', value: 'MS'},
            { label: 'MG', value: 'MG'},
            { label: 'PA', value: 'PA'},
            { label: 'PB', value: 'PB'},
            { label: 'PR', value: 'PR'},
            { label: 'PE', value: 'PE'},
            { label: 'PI', value: 'PI'},
            { label: 'RJ', value: 'RJ'},
            { label: 'RN', value: 'RN'},
            { label: 'RS', value: 'RS'},
            { label: 'RO', value: 'RO'},
            { label: 'RR', value: 'RR'},
            { label: 'SC', value: 'SC'},
            { label: 'SP', value: 'SP'},
            { label: 'SE', value: 'SE'},
            { label: 'TO', value: 'TO'}
          ]"
          @change="onEstadoChange"
      />

      <FormKit
          type="select"
          name="vehicle_plate_city"
          id="cidadeEmplacamento"
          label="Cidade do emplacamento?*"
          validation="required"
          :validation-messages="{ required: 'A cidade de emplacamento é obrigatória' }"
          :options="cidadesOptions"
      />

      <FormKit
          type="hidden"
          id="vehicle_plate_city_ibge_code"
          name="vehicle_plate_city_ibge_code"
      />

      <FormKit
          type="text"
          name="vehicle_identification_number"
          label="Chassi*"
          validation="required|length:17"
          :validation-messages="{
            required: 'O chassi é obrigatório',
            length: 'Quantidade de caractéres inválida'
          }"
      />

      <FormKit
          type="text"
          name="vehicle_renavam"
          label="Renavam*"
          validation="required|length:11"
          :validation-messages="{
            required: 'O renavam é obrigatório',
            length: 'Quantidade de caractéres inválida'
          }"
      />

      <FormKit
          type="text"
          name="vehicle_certificate"
          label="CRLV*"
          validation="required"
          :validation-messages="{
            required: 'O CRLV é obrigatório',
            length: 'Quantidade de caractéres inválida'
          }"
      />

      <template #submit>
        <FooterButton />
      </template>
  </FormKit>
</template>

<script>
  import FooterButton from '../../components/FooterButton.vue'
  import { useRouter } from 'vue-router'
  import { useStore } from '../../../stores/cadastro.js'
  import { normalizeField } from '@/lib/formkit/formkitUtil';

  export default {
    components: {
      FooterButton
    },
    data() {
      return {
        vehicle_plate: '',
        vehicle_plate_state: '',
        vehicle_plate_city: '',
        vehicle_identification_number: '',
        vehicle_renavam: '',
        vehicle_certificate: '',
        cidadesOptions: []
      };
    },
    setup() {
      const router = useRouter()
      const store = useStore()

      const confirmData = async (formData) => {
        await store.updateVehicleData(formData)
        router.push({ name: 'VehicleSecondForm' })
      }

      return {
        confirmData,
        normalizeField,
        vehiclePlateRegex: /[A-Z]{3}-[0-9][0-9A-Z][0-9]{2}/,
      }
    },
    methods: {
      onEstadoChange(event) {
        this.vehiclePlateState = event.target.value;
        this.setupCidadeEmplacamento();
      },
      setupCidadeEmplacamento() {
        if (this.vehiclePlateState) {
          if (this.tomSelectInstance) {
            this.tomSelectInstance.destroy();
          }

          this.tomSelectInstance = new TomSelect('#cidadeEmplacamento', {
            valueField: 'name',
            labelField: 'name',
            placeholder: 'Digite o nome da cidade',
            searchField: ['name'],
            load: (query, callback) => {
              if (!query.length) return callback();
              fetch(`/_api_proxy/address/cities?search=${encodeURIComponent(query)}&state=${encodeURIComponent(this.vehiclePlateState)}`)
                .then(response => response.json())
                .then(json => callback(json.items))
                .catch(() => callback());
            },
            render: {
              option: (item, escape) => {
                return `
                  <div class="py-2 d-flex">
                    <div class="mb-1">
                      <span class="h5">${escape(item.name)} - ${escape(item.state)}</span>
                    </div>
                  </div>`;
              },
              item: (data, escape) => {
                return `
                  <span
                    data-ibge-code="${escape(data.ibge_code)}"
                    data-name="${escape(data.name)}"
                  >${escape(data.name)}</span>`;
              },
            },
          });
        }
      },

      /**
       * @param {string} value
       */
      normalizeVehiclePlate(value) {
        const clean = value.toUpperCase().replace(/[^0-9A-Z]/g, '');
        return clean.substring(0, 3) + '-' + clean.substring(3);
      }
    },
    watch: {
      vehiclePlateState(newVal) {
        this.setupCidadeEmplacamento();
      }
    }
  };
</script>
<style>
  .ts-control{
    border: none;
    padding: 0;
  }

  .ts-control input {
    font-size: 15px;
    color: #000;
    font-weight: 300;
    padding: 0;
  }
  .h5, .item{
    font-size: 15px;
    color: #000;
    font-weight: 300;
  }
</style>
